export enum Page {
  AUTH = '/auth',
  // Admin Routes
  ADMIN_HOME = '/dom-admin-a3b1c8d9e2f7g4h6i5j0k9l2',
  ADMIN_BALANCE = '/dom-admin-a3b1c8d9e2f7g4h6i5j0k9l2/balance',
  ADMIN_WITHDRAWALS = '/dom-admin-a3b1c8d9e2f7g4h6i5j0k9l2/withdrawals',
  ADMIN_WITHDRAWAL_DETAILS = '/dom-admin-a3b1c8d9e2f7g4h6i5j0k9l2/withdrawals/:id',
  ADMIN_USERS = '/dom-admin-a3b1c8d9e2f7g4h6i5j0k9l2/users',
  ADMIN_USER_DETAILS = '/dom-admin-a3b1c8d9e2f7g4h6i5j0k9l2/users/:id',
  ADMIN_MATRIX_CHANNEL_FORM = '/dom-admin-a3b1c8d9e2f7g4h6i5j0k9l2/matrix-channel-form',
  // User Routes
  USER_DATA_FORM = '/user/data-form',
  INSTRUCTIONS = '/instructions',
  HOME = '/',
  SHOP = '/shop',
  COOKIES_SHOP = '/shop/cookies',
  DIAMONDS_SHOP = '/shop/diamonds',
  COGNITION = '/cognition',
  STONE_ABILITIES = '/cognition/stone-abilities',
  SETTLEMENT_DETAILS = '/settlements/:id',
  SETTLEMENTS_SHOP = '/shop/settlements',
  FRIENDS = '/friends',
  PROFILE = '/profile',
  REFERRAL_TREE = '/profile/referral-tree',
  EDIT_PROFILE = '/profile/edit',
  USER_PROFILE = '/profile/:id',
  TASKS = '/tasks',
  MATRIX_CHANNEL = '/matrix/channels/:id/:index',
  WITHDRAWAL = '/withdrawal',
  BALANCE_HISTORY = '/balance/history',
  ROADMAP = '/roadmap',
  DAILY_CARD_DESCRIPTION = '/daily-card/description',
  DAILY_CARD_PREVIEW = '/daily-card/preview',
  DAILY_CARD_RESULT = '/daily-card/result',
  DAILY_ENERGY = '/daily-energy',
  DAILY_ENERGY_DESCRIPTION = '/daily-energy/description',
  COMPATIBILITY_CALCULATOR = '/compatibility-calculator',
  DEVELOPMENT = '/development/:id',
}
